"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmplifyErrorCode = void 0;
var AmplifyErrorCode;
(function (AmplifyErrorCode) {
    AmplifyErrorCode["NoEndpointId"] = "NoEndpointId";
    AmplifyErrorCode["PlatformNotSupported"] = "PlatformNotSupported";
    AmplifyErrorCode["Unknown"] = "Unknown";
    AmplifyErrorCode["NetworkError"] = "NetworkError";
})(AmplifyErrorCode || (exports.AmplifyErrorCode = AmplifyErrorCode = {}));
